import { type Button, Icon } from '@electronicpartnerio/uic';

const sidebar = (sidebar: HTMLElement) => {
    const btn: Button = sidebar.querySelector('.aside-toggle')!;
    const icon: Icon = btn.querySelector('uic-icon')!;
    let small: boolean = true;

    const handleButtonClick = () => {
        small = !small;
        sidebar.parentElement!.classList.toggle('small', small);
        icon.setAttribute('name', small ? 'menu' : 'menu_open');
    };

    btn.addEventListener('onClick', handleButtonClick);
};

export default sidebar;
